import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { baseURL } from '../../config';
import { openNotification } from '../../components/common/helper';
import { useNavigate } from 'react-router-dom';

const initialState = {
    token: typeof window !== 'undefined' && localStorage.getItem('token'),
    isLoading: false,
    error: null,
    preauths: [],
    property: {},
    preAuthDetails: { isLoading: false, preAuth: {} },
    snapshot: {}
};


export const listPreAuths = createAsyncThunk('preauths/List', async ({ size, page, status, sort, sortField = 'createdTimestamp', sortBy, sortDirection }) => {
    const params = new URLSearchParams({ size, page });
    if (status && status !== 'All') params.append('status', status);
    // Prefer sortBy/sortDirection (v2 API format)
    if (sortBy && sortDirection) {
        params.append('sortBy', sortBy);
        params.append('sortDirection', sortDirection);
    } else {
        const sortParam = sortField && sort ? `${sortField},${sort}` : (sort ? `createdTimestamp,${sort}` : '');
        if (sortParam) params.append('sort', sortParam);
    }
    return await fetch(`${baseURL}provider/pre-authorisation/v2/list?${params.toString()}`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(res => res.json())
        .catch(err => console.log(err))
});


// export const searchPreAuths = createAsyncThunk('preAuths/Search', async ({ query, size, page }) => {
//     return await fetch(`${baseURL}pas/claim/search?query=${query}&size=${size}&pageNumber=${page}`, {
//         method: 'GET',
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": "Bearer " + localStorage.getItem('token')
//         }
//     })
//         .then(res => res.json())
//         .catch(err => console.log(err))
// });


export const getPreAuthDetails = createAsyncThunk('preAuths/getPreAuths', async ({ navigate, preauth_id }) => {
    return await fetch(`${baseURL}provider/pre-authorisation/v2/${preauth_id}/details`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(res => res.json())
        .then(res => {
            if (res?.status !== 200) {
                navigate('/pre-auths')
                openNotification(res?.message, 'Error')
            } else {
                return res;
            }

        })
        .catch(err => console.log(err))
});

export const getExtentions = createAsyncThunk('extensions/list', async ({ navigate, preauth_id }) => {
    return await fetch(`${baseURL}extensions/list`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(res => res.json())
        .then(res => {
            if (res?.status!==200) {
                navigate('/pre-auths')
                openNotification(res?.message, 'Error')
            } else {
                return res;
            }

        })
        .catch(err => console.log(err))
});

export const getExtentionAuthDetails = createAsyncThunk('extensions/extentionId', async ({ navigate, extentionId }) => {
    return await fetch(`${baseURL}extensions/${extentionId}`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(res => res.json())
        .then(res => {
            if (res?.status !== 200) {
                navigate('/pre-auths')
                openNotification(res?.message, 'Error')
            } else {
                return res;
            }

        })
        .catch(err => console.log(err))
});



export const PreAuthSlice = createSlice({
    name: 'preauths',
    initialState: initialState,
    reducers: {
        logOut: (state, actions) => {
            state.isLoading = false;
            state.isAuthenticated = false;
            state.token = null;
            localStorage.clear();
        },
        clearErr: (state, actions) => {
            state.error = null;
        }
    },
    extraReducers(builder) {
        builder.addCase(listPreAuths.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(listPreAuths.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action?.payload?.result?.content){
                state.preauths = action?.payload?.result?.content || [];
                console.log(state.preauths)
                state.property = action?.payload?.result?.property || null;
            }
        });
        builder.addCase(listPreAuths.rejected, (state) => {
            state.isLoading = false;
        });
        // builder.addCase(searchPreAuths.pending, (state) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(searchPreAuths.fulfilled, (state, action) => {
        //     state.preauths = action.payload.result.content
        //     state.property = action.payload.result.property
        //     state.isLoading = false;
        // });
        // builder.addCase(searchPreAuths.rejected, (state) => {
        //     state.isLoading = false;
        // });
        builder.addCase(getPreAuthDetails.pending, (state) => {
            state.preAuthDetails.isLoading = true;
        });
        builder.addCase(getPreAuthDetails.fulfilled, (state, action) => {
            state.preAuthDetails.preauth = action.payload.result
            state.preAuthDetails.isLoading = false;

        });
        builder.addCase(getPreAuthDetails.rejected, (state) => {
            state.preAuthDetails.isLoading = false;
        });
        builder.addCase(getExtentions.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getExtentions.fulfilled, (state, action) => {
            console.log(action.payload?.result?.content)
            state.isLoading = false;
            state.extensions = action.payload?.result?.content;
        
        });
        builder.addCase(getExtentions.rejected, (state) => {
            state.isLoading = false;
        });
        builder.addCase(getExtentionAuthDetails.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getExtentionAuthDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            // API response structure: { status: 200, success: true, result: {...} }
            state.extentionAuthDetails = action.payload?.result || action.payload;
        });
        builder.addCase(getExtentionAuthDetails.rejected, (state) => {
            state.isLoading = false;
        });         
    }
        });
    export const { clearErr } = PreAuthSlice.actions;
    export default PreAuthSlice.reducer;
